export const environment = {
  production: true,
  deploymentUrl: '/o/edu-udo-itmc-dev-mini-book/',
  url: 'https://micro-apps1.itmc.tu-dortmund.de/mini-book-backend/'
};
